<header id="header-container">
  <div class="app-header">
    <h3 class="title">Studies</h3>
  </div>
</header>
